export default __webpack_public_path__ + "static/media/two-steps-verification-illustration-dark.fcf83f3f.svg";